<template>
    <div class="m-report">
        <div v-for="(news, index) of showNewsList" v-bind:key="index" class="m-report-item" @click="showDetail(news, index)">
            <!--<a :href="`report.html?id=${news.id}`">-->
                <h2 class="m-report-title">{{news.title}}</h2>
                <p v-if="index <= 0" class="m-report-desc">
                    {{news.desc}}
                </p>
                <p class="m-report-time">{{news.date | tranTime}}</p>
            <!--</a>-->
        </div>
        <div v-if="this.newsIndex <= this.newsLists.length" class="moreBtn-wrapper">
            <a class="moreBtn" @click="loadMoreNews">加载更多 ></a>
        </div>
    </div>
</template>

<script>
import newsList from 'assets/json/news-list';

export default {
    name: 'Reports',
    data() {
        return {
            newsLists: [],
            showNewsList: [],
            newsIndex: 2,
        };
    },
    methods: {
        setNewsLists() {
            this.newsLists = newsList.newsList.sort((a, b) => {
                const date2Num = date => {
                    return parseInt(date.split('-').join(''));
                };
                if (a.order === b.order) {
                    return date2Num(b.date) - date2Num(a.date);
                }
                return b.order - a.order;
            });
        },
        loadMoreNews() {
            let index = this.newsIndex + 2;
            this.showNewsList = this.newsLists.slice(0, index);
            this.newsIndex = index;
        },
        showDetail(news, index) {
            this.$emit('showDetails', news, index);
        },
    },
    mounted() {
        this.setNewsLists();
        this.loadMoreNews();
    },
    filters: {
        tranTime: function(value) {
            if (!value) return '';
            let arr = value.split('-');
            return arr[0] + '年' + arr[1] + '月' + arr[2] + '日';
        },
    },
};
</script>

<style  lang="less">
.m-report {
    font-family: PingFangSC-Regular;
    position: relative;
    width: 100%;
}
.m-report-item {
    box-sizing: border-box;
    margin: 0 0.607rem;
    border-bottom: 1px solid #eaedf2;
}
.m-report-title {
    font-size: 0.5rem;
    color: #333333;
    letter-spacing: 0;
    line-height: 0.714rem;
    padding-top: 13px;
}
.m-report-desc {
    padding-top: 12px;
    font-size: 0.428rem;
    color: #4a4a4a;
    letter-spacing: 0;
    line-height: 0.785rem;
}
.m-report-time {
    position: relative;
    font-size: 0.428rem;
    color: #898d95;
    letter-spacing: 0;
    line-height: 0.571rem;
    padding-top: 13px;
    padding-bottom: 13px;
}
.moreBtn-wrapper {
    text-align: center;
    padding-top: 1rem;
    padding-bottom: 1.3rem;
}
.moreBtn {
    display: inline-block;
    border: 1px solid #41b466;
    border-radius: 2px;
    width: 112px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    color: #41b466;
}
</style>
